export function baseGet(
  obj: object,
  pathIn: string | any[],
): { exists: boolean; value: any } {
  function normalizePath(path: string | any[]): any[] {
    if (typeof path === 'string') {
      path = path.split('.');
    }
    return path;
  }

  const path: any[] = normalizePath(pathIn);

  const result = path.reduce(
    function (acc, key) {
      return {
        exists: acc.exists && acc.value && acc.value.hasOwnProperty(key),
        value: acc.value && acc.value[key],
      };
    },
    {
      exists: true,
      value: obj,
    },
  );

  if (!result.exists) {
    delete result.value;
  }

  return result;
}
